export default __webpack_public_path__ + "bede6b6e2640a64034fd461a641a5a59.png";